<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters v-if="showGatewayPopup">
        <v-col cols="12">
          <qr-edit-gateway
            v-model="showGatewayPopup"
            :sections="gatewaySections"
            :form-data="data"
            @edit-all="handleEditAll"
            @save="qrUpdate(true)"
            @cancel="onCancel"
          >
            <template v-slot:preview style="position: relative; min-height: 100%;">
              <v-card
                v-if="loading"
                class="d-flex align-center justify-center mt-10"
                flat
                min-height="50vh"
              >
                <v-progress-circular indeterminate size="50" width="5" color="gray" />
              </v-card>
              <div v-else class="sticky-preview">
                <view-appointment v-model="data" :loading="loading" :qr-svg-data-url="qrSvgDataUrl"/>
              </div>
            </template>
          </qr-edit-gateway>
        </v-col>
      </v-row>

      <v-row class="pa-2" no-gutters v-if="!showGatewayPopup">
        <v-col class="pa-2" cols="12">
          <v-progress-linear v-show="loading" height="5" indeterminate />
        </v-col>

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <view-appointment v-model="data" :loading="loading" :qr-svg-data-url="qrSvgDataUrl"/>
        </v-col>

        <v-col cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>وارد کردن اطلاعات منو نوبت‌دهی</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="res.title"
                        :disabled="e6 > 1"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام منو نوبت‌دهی"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام منو نوبت‌دهی"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        id="qr-address"
                        ref="address-field"
                        v-model="res.identifier"
                        :domain-id="res.domain_id"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        outlined
                        persistent-hint
                        readonly
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"

                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="آدرس کیوآر"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <v-card-actions v-if="!!data.appointments" class="justify-end">
                  <v-switch
                    v-model="data.appointments.onlineShop"
                    class="ma-0"
                    dense
                    hide-details
                    inset
                    label="رزرو آنلاین"
                  />
                </v-card-actions>
                  <div class="mb-4 x-mx-4">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>

                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true);
                      if(!!data?.appointments?.onlineShop)
                        e6++;
                    if(!data?.appointments?.onlineShop)
                        goTo('qr/list')" 
                  />
                </div>
              </v-stepper-content>

              <v-stepper-step
                v-if="!!data.appointments && data.appointments.onlineShop"
                :complete="e6 > 2"
                class="px-0 px-md-4"
                step="2"
              >
                تنظیمات رزرو نوبت
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                <qr-appointment-manager ref="appointmentSetting" 
                                @save-required="AutoSave && qrUpdate(false)"/>

                <div class="row mx-auto">
                  <div class="col-md-6">
                    <prev-btn :loading="loading" @click="e6 = 1" />
                  </div>

                  <div class="col-md-6">
                    <next-btn :loading="loading" @click="updateShopSettings" />
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import PrevBtn from "@/view/content/fragments/prevBtn.vue";
import { mapActions } from "vuex";
import ViewAppointment from "@/view/pages/businessPage/components/view/viewAppointment.vue";
import QrAppointmentManager from "@/view/pages/otherQrTypes/appointment/cm/qrAppointmentManager.vue";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editAppointment",

  components: {
    QrAppointmentManager,
    ViewAppointment,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrEditGateway,
    HelpInfo,
    HelpInfoWrapper,
    AtomSpinner
  },

  data: () => ({
    isAutoSaving: false, 
    AutoSave:false,
    showGatewayPopup: false,
    helpData: [],
    serviceName: "Qrland",
    componentName: "editAppointment",
    data: {},
    e6: 1,
    errors: {},
    loading: false,
    res: {},
    qrSvgDataUrl:'',

  }),

  created() {
    this.showGatewayPopup = this.$route?.query?.gateway === 'true';
  },

  mounted() {
    this.fetchData();
  },

  computed: {
    specialInfo() {
      return [
        {
          name: "bannerSelector",
          value: "",
          title: this.$t("edit_bpage_special_info_special.upload_banner"),
          subtitle: "",
          icon: "image-area",
          model: "banner",
        },
        {
          name: "Appointments",
          value: "",
          title: this.$t("edit_bpage_special_info_special.manage_appointments"),
          subtitle: "",
          icon: "ticket-account",
          model: "appointments",
        },
        {
          name: "PicSelector",
          value: "",
          title: this.$t("edit_bpage_special_info_special.photo_gallery"),
          subtitle: "",
          icon: "image-outline",
        },
        {
          name: "VideoGallery",
          value: "",
          title: this.$t("edit_bpage_special_info_special.video_gallery"),
          subtitle: "",
          icon: "video-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: this.$t("edit_bpage_special_info_special.feedback"),
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "textCards",
          value: "",
          title: this.$t("edit_bpage_special_info_special.user_information"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t("edit_bpage_special_info_special.add_social_media"),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "WorkSheet",
          value: "",
          title: this.$t("edit_bpage_special_info_special.working_hours"),
          subtitle: "",
          icon: "timetable",
          model: "WorkSheet",
        },
      ];
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    gatewaySections() {
      return this.specialInfo.map((item) => {
        return { ...item, description: item.title };
      });
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    
    handleEditAll() {
      this.showGatewayPopup = false;
    },
    onCancel() {
      this.$router.push({ name: "qr.list" });
    },

    fetchData() {
      this.loading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          let info = data.data.data;
          this.res = data.data;
          this.qrSvgDataUrl= data?.data?.img_url||''; 


          if (!Object.hasOwn(info.data.appointments, "onlineShop")) {
            info.data.appointments.onlineShop = true;
            this.$nextTick(() => {
              this.$refs.appointmentSetting?.fetchSettings();
              this.$refs.appointmentSetting?.fetchNumbers();
            });
          } else if (info.data.appointments.onlineShop) {
            this.$nextTick(() => {
              this.$refs.appointmentSetting?.fetchSettings();
              this.$refs.appointmentSetting?.fetchNumbers();
            });
          }

          this.data = info.data;
          this.setCreatedQrID(data.data.id);
        })
        .finally(() => (this.loading = false));
    },
    
    qrUpdate(isGateway = false) {
      if (isGateway || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }

      const data = new FormData();
      data.append("type", "appointment");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);
      data.append("_method", "PUT");
      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.data,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          if(!this.AutoSave)
            this.$toast.success("کیوآر نوبت دهی شما با موفقیت ویرایش شد.");
          this.$root.$emit("submitFeedback");
          
          // if (isGateway) {
          //   return; 
          // }

          // if (this.data.appointments.onlineShop) {
          //   this.e6++;
          // } else {
          //   this.$router.replace({ name: "qr.list" });
          // }
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    
    updateShopSettings() {
      this.loading = true;
      this.$refs.appointmentSetting.setCartSetting().finally(() => {
        this.setShopNotice();
      });
    },
    setShopNotice() {
      this.$refs.appointmentSetting.setShopNotice().finally(() => {
        this.loading = false;
        this.$router.replace({ name: "qr.list" });
      });
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important;
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}

[dir="rtl"] .contentinfo,
[dir="rtl"] .rowinfo {
  text-align: right;
}
[dir="ltr"] .contentinfo,
[dir="ltr"] .rowinfo {
  text-align: left;
}
</style>
